import { Quaternion, Vector3 } from "three";

let imageTargetStates: { [key: string]: any } = {};

const createImageTargetStates = (imageTargetNames: string[]) => {
  imageTargetNames.forEach((element: string) => {
    imageTargetStates[element] = {
      found: false,
      position: new Vector3(),
      rotation: new Quaternion(),
      scale: new Vector3(),
      initiated: false,
    };
  });
};

const setImageTargetState = (event: any, found: boolean) => {
  const imageTargetEvent = event.e;
  imageTargetStates[imageTargetEvent.name].found = found;
  imageTargetStates[imageTargetEvent.name].initiated = true;
  imageTargetStates[imageTargetEvent.name].position.copy(
    imageTargetEvent.position
  );
  imageTargetStates[imageTargetEvent.name].rotation.copy(
    imageTargetEvent.rotation
  );
  imageTargetStates[imageTargetEvent.name].scale.setScalar(
    imageTargetEvent.scale
  );

  return imageTargetStates;
};

export { imageTargetStates, createImageTargetStates, setImageTargetState };
